import MissionCommon from "@/router/common-routes/mission/mission-common";
import { useMissionStore } from "@/store/modules/mission";
import checkMissionSupervisionAccess from "@/router/middleware/checkSupervisionAccess";

const Mission = () =>
  import(/* webpackChunkName: "Mission" */ "@/components/ssp/missions/Mission.vue");

import MissionChildrens from "./missions/mission-childrens";

const setCurrentMission = async (to, from, next) => {
  if (to.params.missionId !== from.params.missionId) {
    const missionStore = useMissionStore();
    await missionStore.retrieveMission(to.params.missionId);
  }
  next();
};

export default [
  ...MissionCommon,
  {
    path: ":missionId",
    component: Mission,
    children: MissionChildrens,
    beforeEnter: [setCurrentMission, checkMissionSupervisionAccess()],
  },
];
